"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _index = _interopRequireDefault(require("../index"));
var version = "v2";
var _default = exports["default"] = {
  getComponents: function getComponents(collectionName) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _index["default"].get("/".concat(version, "/collections/").concat(collectionName, "/components/"), {
      params: params,
      paramsSerializer: function paramsSerializer(params) {
        return _qs["default"].stringify(params, {
          indices: false
        });
      }
    });
  }
};